import {fetchConToken} from '../helpers/fetch'

const getAllPartners = async (options: any, token: string) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(`colaborador?${queryString}`, {}, 'GET', token)

  const body = await resp.json()

  return body
}

const getAllPartnersDashboard = async (options: any, token: string) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(`colaborador/dashboard?${queryString}`, {}, 'GET', token)

  const body = await resp.json()

  return body
}

const getAllPartnersSelect = async (options: any) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(`colaborador/list/user_dni?${queryString}`, {}, 'GET')

  const body = await resp.json()

  return body
}

const getAllPartnersPag = async (currentPage: any, numberData: any, options: any) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(
    `colaborador/historialdocument/${currentPage}/${numberData}?${queryString}`,
    {},
    'GET'
  )

  const body = await resp.json()

  return body
}

const deletePartner = async (id: string) => {
  const resp = await fetchConToken(`colaborador/${id}`, {}, 'DELETE')
  const body = await resp.json()

  return body
}

const updatePartner = async (id: string, updatedData: any) => {
  const resp = await fetchConToken(`colaborador/${id}`, updatedData, 'PUT')
  const body = await resp.json()

  return body
}

const getPartnersForValidation = async () => {
  const resp = await fetchConToken('colaborador/validationList', {}, 'GET')

  const body = await resp.json()

  return body
}

const approvePartner = async (options: any) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(`colaborador/approve?${queryString}`, {}, 'POST')

  const body = await resp.json()

  return body
}

const getAllAprovedPartners = async (options: any) => {
  const qs = new URLSearchParams(options).toString()
  const resp = await fetchConToken(`colaborador/approved_collaborators?${qs}`, {}, 'GET')
  return await resp.json()
}

const getAllAprovedPartnersDashboard = async (options: any) => {
  const qs = new URLSearchParams(options).toString()
  const resp = await fetchConToken(`colaborador/approved_collaborators/dashboard?${qs}`, {}, 'GET')
  return await resp.json()
}

const closeProcess = async (payload: {
  partnerId: string
  processStatus: string
  extraMessage: string
}) => {
  const resp = await fetchConToken('colaborador/closeProcess', payload, 'POST')
  const body = await resp.json()
  return body
}

const changeStatusPartner = async (idFicha: string, status: string) => {
  const resp = await fetchConToken(
    'colaborador/changeStatus',
    {
      idFicha,
      status,
    },
    'POST'
  )

  return await resp.json()
}

const getUsersCountByUnit = async () => {
  const resp = await fetchConToken('colaborador/getUsersCount/unit', {}, 'GET')

  return await resp.json()
}

const getUsersWithPendingDocuments = async () => {
  const resp = await fetchConToken('colaborador/pending_docs', {}, 'GET')

  return await resp.json()
}

const resendEmail = async (id: string) => {
  const resp = await fetchConToken('colaborador/resend-email', {id}, 'POST')
  const body = await resp.json()

  return body
}

const getRolsByUrl = async (url: string) => {
  const resp = await fetchConToken('colaborador/get_rols_by_url', {url}, 'POST')
  const body = await resp.json()
  return body
}

export {
  approvePartner,
  changeStatusPartner,
  closeProcess,
  deletePartner,
  getAllAprovedPartners,
  getAllAprovedPartnersDashboard,
  getAllPartners,
  getAllPartnersDashboard,
  getAllPartnersPag,
  getAllPartnersSelect,
  getPartnersForValidation,
  getUsersCountByUnit,
  getUsersWithPendingDocuments,
  resendEmail,
  updatePartner,
  getRolsByUrl,
}
